import React, { useState } from "react";
import "../styles/navbar.css";
import lotus from "../images/lotus.png";
import { Link } from "react-router-dom";

function NavBar() {

	return (
	  <nav className="navigation">
	    <img style={{ width: "100px", height: "75px" }} src={lotus} alt="Light blue lotus flower."/>
	      <div className="navigation-menu">
	        <ul>
	          <li>
				<Link to="/">Home</Link>
	          </li>
			  <li>
				<Link to="/ai-projects">AI</Link>
			  </li>
	          <li>
				<Link to="/news">News</Link>
	          </li>
	          <li>
				<Link to="/resume">Resume</Link>
	          </li>
	          <li>
				<Link to="/contact">Contact</Link>
	          </li>
	        </ul>
	      </div>
      </nav>
    );
}

export default NavBar;
